module.exports = __webpack_public_path__ + "img/LI.ff9117d5.svg";